import { useSelector } from 'react-redux';

export const useTheme = (component) => {
	const { dealsTheme, isDealsPage } = useSelector((state) => state);

	let theme = {
		titleBanner: {
			background: 'bg-darkgreen',
			title: 'text-white',
			text: 'text-white',
		},
		financeBanner: {
			background: 'bg-white',
			aoFinance: 'text-secondary',
			title: 'text-primary',
			repExample: {
				title: 'text-tertiary',
				examples: {
					title: 'text-primary',
					description: 'text-tertiary',
				},
			},
			terms: 'text-tertiary',
		},
		weRecommend: {
			background: 'bg-darkgreen',
			text: 'text-white',
			fill: '#14C35A',
		},
		middleBanner: {
			background: 'bg-white',
			title: 'text-primary',
			description: 'text-primary',
			link: 'text-cta-action',
		},
		financeFooter: {
			background: 'bg-darkgreen',
			title: 'text-white',
			text: 'text-white',
			fill: '#FFE3C2',
		},
		seo: {
			background: 'bg-darkgreen',
			text: 'text-white',
			fill: '#14C35A',
		},
	};

	if (isDealsPage) {
		switch (dealsTheme) {
			case 1:
				theme = {
					titleBanner: {
						background: 'bg-bread',
						title: 'text-primary',
						text: 'text-secondary',
					},
					financeBanner: {
						background: 'bg-bread',
						aoFinance: 'text-secondary',
						title: 'text-primary',
						repExample: {
							title: 'text-tertiary',
							examples: {
								title: 'text-primary',
								description: 'text-tertiary',
							},
						},
						terms: 'text-tertiary',
					},
					weRecommend: {
						background: 'bg-bread',
						text: 'text-primary',
						fill: '#12C35A',
					},
					middleBanner: {
						background: 'bg-bread',
						title: 'text-primary',
						description: 'text-secondary',
						link: 'text-primary',
					},
					financeFooter: {
						background: 'bg-bread',
						title: 'text-primary',
						text: 'text-secondary',
						fill: '#12C35A',
					},
					seo: {
						background: 'bg-bread',
						text: 'text-primary',
						fill: '#12C35A',
					},
				};
				break;
			case 2:
				theme = {
					titleBanner: {
						background: 'bg-heat',
						title: 'text-primary',
						text: 'text-primary',
					},
					financeBanner: {
						background: 'bg-heat',
						aoFinance: 'text-secondary',
						title: 'text-primary',
						repExample: {
							title: 'text-primary',
							examples: {
								title: 'text-primary',
								description: 'text-primary',
							},
						},
						terms: 'text-primary',
					},
					weRecommend: {
						background: 'bg-simmer',
						text: 'text-primary',
						fill: '#F96155',
					},
					middleBanner: {
						background: 'bg-heat',
						title: 'text-primary',
						description: 'text-primary',
						link: 'text-primary',
					},
					financeFooter: {
						background: 'bg-heat',
						title: 'text-primary',
						text: 'text-primary',
						fill: '#FFD8D2',
					},
					seo: {
						background: 'bg-simmer',
						text: 'text-primary',
						fill: '#F96155',
					},
				};
				break;

			case 3:
				theme = {
					titleBanner: {
						background: 'bg-water',
						title: 'text-lightgreen',
						text: 'text-steam',
					},
					financeBanner: {
						background: 'bg-water',
						aoFinance: 'text-lightgreen',
						title: 'text-lightgreen',
						repExample: {
							title: 'text-steam',
							examples: {
								title: 'text-lightgreen',
								description: 'text-steam',
							},
						},
						terms: 'text-steam',
					},
					weRecommend: {
						background: 'bg-water',
						text: 'text-lightgreen',
						fill: '#BEFCC8',
					},
					middleBanner: {
						background: 'bg-water',
						title: 'text-lightgreen',
						description: 'text-steam',
						link: 'text-lightgreen',
					},
					financeFooter: {
						background: 'bg-water',
						title: 'text-lightgreen',
						text: 'text-steam',
						fill: '#BEFCC8',
					},
					seo: {
						background: 'bg-water',
						text: 'text-white',
						fill: '#BEFCC8',
					},
				};
				break;
			default:
				break;
		}
	}

	return component ? theme?.[component] ?? theme : theme;
};
